<template>
  <div class="ultra-utv">
    <!-- 移动端loading -->
    <Loading v-if="isMobile && isLoading" />
    <!-- 主图 -->
    <CarMainBanner :is-mobile="isMobile"
      banner-name="ultra-utv"
      :banner-url="imgUrlPrefix + mainBanner"
      font-color-type="light"
      mobile-font-color="light"
      :title="mainTitle"
      sub-title="专业级越野玩乐UTV"
      @pageLoad="pageLoad"
    />
    <div>
      <img class="img-cover" :src="`${imgUrlPrefix}${ isMobile ? 'm-sec1_1.jpg' : 'sec1_1.jpg' }`" alt="" />
    </div>

    <!-- 车辆系列展示组件-1行3列 -->
    <CarSeriesComponent :car-series-obj="carSeriesObj" />

    <!-- 底部生活方式组件 -->
    <CarLifeComponent :bg-img="carLifeBg" />

  </div>
</template>

<script>
import Loading from '../components/Loading.vue'
import CarMainBanner from '../components/CarMainBanner.vue'
import CarSeriesComponent from '../components/CarSeriesComponents.vue'
import CarLifeComponent from '../components/CarLifeComponent.vue'
import { checkIsMobile } from '../utils/tools.js'
import { fadeAnimate, destroyFadeAnimate } from '../utils/animation.js'
export default {
  components: {
    Loading,
    CarMainBanner,
    CarSeriesComponent,
    CarLifeComponent,
  },

  mounted() {
    fadeAnimate();
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice);
  },
  beforeDestroy() {
    destroyFadeAnimate();
    window.removeEventListener('resize', this.checkDevice);
  },
  computed: {
    mainBanner() {
      return this.isMobile ? 'm-main.jpg' : 'main.jpg'
    },
    mainTitle() {
      return this.isMobile ? '无极限<br>不玩乐' : '无极限，不玩乐'
    },
    // 车辆系列数据
    carSeriesObj() {
      return {
        logo: this.imgUrlPrefix2 + 'series-logo.png',
        desc: '赛事级越野专属配置   专业团队调校',
        title: this.isMobile ? 'PERFORMANCE<br>运动赛事系列' : 'PERFORMANCE运动赛事系列',
        series: 'PERFORMANCE',
        carList: [
          { img: this.imgUrlPrefix2 + 'sec8_1.png', name: 'Ultra', link: 'Ultra'},
          { img: this.imgUrlPrefix2 + 'sec8_2.png', name: '达喀尔', link: 'UltraT1'},
          { img: this.imgUrlPrefix2 + 'sec8_3.png', name: '巴丹100', link: ''},
        ]
      }
    },
    carLifeBg() {
      return this.isMobile ? '/assets/images/m-utv-life-bg.jpg' : '/assets/images/utv-life-bg.jpg'
    },
  },
  data() {
    const imgUrlPrefix = '/assets/images/ultraUtv/'
    const imgUrlPrefix2 = '/assets/images/ultra/'
    return {
      isLoading: true,
      isMobile: false,
      imgUrlPrefix, // 图片地址前缀
      imgUrlPrefix2,
      
    }
  },
  methods: {
    checkDevice() {
      this.isMobile = checkIsMobile()
    },
    pageLoad() {
      this.isLoading = false
    }
  },
}
</script>

<style lang="less" scoped>

@media (max-width: @mobile-width) {

}
</style>